"use client";

import FieldsFormatter from "@/components/organisms/admin/FieldsFormatter";
import { Button } from "@/components/atoms/Button";
import { TreeConfig, FormState, Section } from "../types";

interface ParentComponentSectionProps {
  formState: FormState;
  treeConfig: TreeConfig;
  parentComponentFieldsConfig: any[];
  onFieldsUpdate: (data: any) => void;
  onSave: (callback: (updatedSection: Section) => void) => void;
  onSaveCallback: (updatedSection: Section) => void;
}

export const ParentComponentSection = ({
  formState,
  treeConfig,
  parentComponentFieldsConfig,
  onFieldsUpdate,
  onSave,
  onSaveCallback,
}: ParentComponentSectionProps) => {
  if (parentComponentFieldsConfig.length === 0) {
    return null;
  }

  return (
    <div className="mb-6 pb-6 border-b">
      <h3 className="font-semibold mb-4">
        {treeConfig.parentComponentTitle || "Parent Component Settings"}
      </h3>
      <FieldsFormatter
        data={formState.parentComponentFields}
        fields={parentComponentFieldsConfig}
        updateParent={true}
        onChange={onFieldsUpdate}
        validationErrors={formState.parentComponentFieldErrors}
        validationMessages={{}}
        className="p-0 bg-transparent"
      />
      <div className="mt-4">
        <Button
          onClick={() => onSave(onSaveCallback)}
          classType="admin"
          className="w-full"
        >
          {treeConfig.parentComponentSaveButtonText || "Save Parent Component Settings"}
        </Button>
      </div>
    </div>
  );
};

